import { Button, Col, Row, Form } from "antd";
import React, { useRef, useState, useEffect } from "react";
import { FormBox, InputBox } from "../AntdAddons";
import GooglePlay from "../../assets/images/icon/GooglePlay.svg";
import { ReactComponent as BackIcon } from "../../assets/images/icon/backToTop.svg";
import AppStore from "../../assets/images/icon/AppStore.svg";
import FormComponent from "./FormComponent";
import { ReactComponent as ArrowRight } from "../../assets/images/icon/backToTop.svg";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import { ReactComponent as Ellipse } from "../../assets/images/icon/Ellipse.svg";
import { createNewsLetterRecord } from "../../store/CommonSlice";
import { useAppDispatch } from "../../store/app";
import { assignErrorToInput } from "../../store/api";
import { randomnumbersubstring } from "../../utils/GlobalFunction";
import { rules } from "./rules";
import { validateFields } from "../../config/Global";

const FooterPage: React.FC<any> = () => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const dispatch = useAppDispatch();
  const [disabledSave, setDisabledSave] = useState(true);
  const onChange = (value: string | null) => {
    if (value) {
      setDisabledSave(false); // Enable the button when the reCAPTCHA is completed
    } else {
      setDisabledSave(true); // Disable the button when the reCAPTCHA is not completed
    }
  };

  const resetCaptcha = () => {
    form.setFieldsValue({ captcha: randomnumbersubstring() });
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setDisabledSave(true); // Disable the button when the reCAPTCHA is reset
    }
  };

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 600) {
      setVisible(true);
    } else if (scrolled <= 600) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,

      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  useEffect(() => {
    form.setFieldsValue({ captcha: randomnumbersubstring() });
  }, [form]);

  const onValuesNewsLetterChange = () => {
    validateFields(form, setDisabledSave);
  };

  const handleNewsLetterSubmit = (values: any) => {
    // Handle form submission logic here
    setDisabledSave(true);

    const multipartFormData = new FormData();
    multipartFormData.append("email", values.newsletter_email);
    multipartFormData.append("captcha", values.captcha);

    dispatch(createNewsLetterRecord(multipartFormData))
      .then(() => {
        form.resetFields();
        resetCaptcha();
        setDisabledSave(false);
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.messages);
      })
      .finally(() => setDisabledSave(false));
  };
  window.addEventListener("scroll", toggleVisible);

  return (
    <>
      <footer className="container" id="contactus">
        <Row>
          <Col span={12}>
            <div className="subscribe">
              <Row>
                <h3>Subscribe to app update</h3>
                <FormBox
                  form={form}
                  className="subscribeForm"
                  onFinish={handleNewsLetterSubmit}
                  onValuesChange={onValuesNewsLetterChange}
                >
                  <InputBox.Text
                    required
                    placeholder="Your email"
                    name="newsletter_email"
                    rules={rules.email()}
                  />
                  <Button
                    className="commanBtn"
                    htmlType="submit"
                    disabled={disabledSave}
                  >
                    <span className="arrowIcon">
                      <ArrowRight />
                    </span>
                    <span className="beforeIcon"></span>
                    <span>Subscribe</span>
                  </Button>
                  <div className="captchaWrap">
                    <Form.Item name="captcha">
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={`${process.env.REACT_APP_CAPTCHA_SITE_KEY}`} // site key
                        onChange={onChange}
                      />
                    </Form.Item>
                  </div>
                </FormBox>
              </Row>
            </div>
            <div className="bottomContent">
              <Row>
                <Col className="conatct" span={12}>
                  <h3>Contact Us on</h3>
                  <div className="contactTel">
                    <a href="tel">
                      {" "}
                      +91 704 604 3434<span>(INDIA)</span>
                    </a>
                  </div>
                </Col>
                <Col span={12} className="conatct download">
                  <div>
                    <h3>Download App Now !</h3>
                    <div className="conatctImg">
                      <Link
                        to="https://play.google.com/store/apps/details?id=com.kapturely&pcampaignid=web_share"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={GooglePlay} />
                      </Link>
                      <Link
                        to="https://apps.apple.com/us/app/kapturely-your-lead-organiser/id6503331885"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={AppStore} />
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="address">
                <Col span={12}>
                  <h3>Address</h3>
                  <a
                    href="https://www.google.com/maps/place/Silicon+IT+Hub+Pvt+Ltd/@23.0095704,72.5060674,17z/data=!3m2!4b1!5s0x395e9b279b35b92d:0x2794cae1be2ad420!4m6!3m5!1s0x395e84bd69664d4b:0x6710aa351fb5c1c0!8m2!3d23.0095704!4d72.5060674!16s%2Fg%2F1263hfr4w?entry=ttu"
                    target="_blank"
                    rel="noreferrer"
                  >
                    B1-Ground Floor, Safal Profitaire, Corporate Road, Prahlad
                    Nagar, Ahmedabad, Gujarat, India - 380015
                  </a>
                </Col>
              </Row>
            </div>
          </Col>
          <Col span={12}>
            <FormComponent />
          </Col>
        </Row>
        <Row className="paddingRow">
          <Col xs={24} xl={18} sm={24} md={12} lg={12}>
            <h4>
              <span>©{new Date().getFullYear()} By </span>kapturely
            </h4>
          </Col>
          <Col xs={24} xl={6} sm={24} md={12} lg={12} className="footer-menu">
            <Link to="/terms-conditions">Terms & Conditions</Link>
            <Ellipse />
            <Link to="/privacy-policy">Privacy Policy</Link>
          </Col>
        </Row>
        <Row className="powered-by">
          <Col span={24}>
          
          Powered by <Link to="https://www.siliconithub.com/" target="_blank">Silicon IT hub</Link>
          </Col>
        </Row>
        {/* <BackTop>
                    <div className="ant-back-top-inner">
                        <BackIcon/>
                    </div>
                </BackTop> */}
        <button
          onClick={scrollToTop}
          style={{
            display: visible ? "block" : "none",
          }}
          className="ant-back-top-inner"
        >
          <BackIcon />
        </button>
      </footer>
    </>
  );
};

export default FooterPage;
